import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/basketballCard.css';
// helpers
import {getText} from '../../../../../helpers/localization';
import ImageLoader from 'react-load-image';
import {ASSETS_URL} from '../../../../../constants/endpoints';
import {getGameFromChannel} from "../../../helpers/gameHelpers";
import {BASKET_BALL_EURO, VPP_BASKETBALL_NBA} from "../../../../../constants/identifiers";

const mapStateToProps = (state, ownProps) => {
    return {
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events
    };
};

class SelectedBasketballCard extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events
        };
    }

    _isFromEuropeanChannel(selectedEvent) {
        return selectedEvent.eventType === BASKET_BALL_EURO;
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let selectedEvent = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        let isDesktopMode = storeData.vpp.isDesktopMode;

        let showActive = this.props.showActive;
        let activeEvent = storeData.vpp.events[0];

        let teamOneJersey = showActive == true ? activeEvent.teamOne.split(' ').join('') : selectedEvent.teamOne.split(' ').join('');
        let teamTwoJersey = showActive == true ? activeEvent.teamTwo.split(' ').join('') : selectedEvent.teamTwo.split(' ').join('');

        let awayTeamKit = showActive == true ? (activeEvent.awayTeamKit.toString() === '0'
            ? '_Home'
            : '_Away') : (selectedEvent.awayTeamKit.toString() === '0'
            ? '_Home'
            : '_Away');
        let showTeamName = showActive == true ? `${style.gameTitle} ${style.gameTitleBannerMobile}` : style.gameTitle;
        let titleBanner = showActive == true ? style.gameTitleBannerTop : style.gameTitleBannerBottom;
        let basketballIconStyle = showActive == true ? style.basketballIcon : style.SelectedbasketballIcon;
        let european = this._isFromEuropeanChannel(selectedEvent);
        let teamTwo = getText(showActive === true ? activeEvent.teamTwo : selectedEvent.teamTwo, this.props.store);
        let versusText = getText(european ? 'VS' : 'AT', this.props.store);
        let teamOne = getText(showActive === true ? activeEvent.teamOne : selectedEvent.teamOne, this.props.store);
        let leftTeamName = european ? teamOne : teamTwo;
        let rightTeamName = european ? teamTwo : teamOne;
        let awayTeamSilk = ASSETS_URL + getGameFromChannel(showActive == true ? activeEvent.channel : selectedEvent.channel, storeData.vpp.games).assetsPath + "/silks/half/" + teamTwoJersey + awayTeamKit + ".png";
        let homeTeamSilk = ASSETS_URL + getGameFromChannel(showActive == true ? activeEvent.channel : selectedEvent.channel, storeData.vpp.games).assetsPath + "/silks/half/" + teamOneJersey + "_Home.png";
        let leftTeamSilk = european ? homeTeamSilk : awayTeamSilk;
        let rightTeamSilk = european ? awayTeamSilk : homeTeamSilk;
        let showIcon = activeEvent.channel === VPP_BASKETBALL_NBA && isDesktopMode && showActive ? false : true;
        return (
            <div id={'basketball_card'} className={`${titleBanner}`}>
                <div className={style.teamNameImage}>
                    {showIcon && <div className={style.imageLoader}>
                        <ImageLoader
                            src={leftTeamSilk}>
                            <img
                                src={leftTeamSilk}
                                className={`${basketballIconStyle}`}
                                alt={`icon_${showActive == true ? activeEvent.teamTwo : selectedEvent.teamTwo}`} />
                            <div>{''}</div>
                            <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={style.basketballIcon}
                                alt={`loading`} />
                        </ImageLoader>
                    </div>}
                    <div className={`${showTeamName}`}>{leftTeamName}</div>
                </div>
                <div className={style.versus}>{versusText}</div>
                <div className={style.teamNameImage}>
                    <div className={`${showTeamName}`}>{rightTeamName}</div>
                    {showIcon && <div className={style.imageLoader}>
                        <ImageLoader
                            src={rightTeamSilk}>
                            <img
                                src={rightTeamSilk}
                                className={`${basketballIconStyle}`}
                                alt={`icon_${showActive == true ? activeEvent.teamOne : selectedEvent.teamOne}`} />
                            <div>{''}</div>
                            <img src={`${ASSETS_URL}miscellaneous/loading.gif`} className={style.basketballIcon}
                                alt={`loading`} />
                        </ImageLoader>
                    </div>}                 
                </div>
            </div>

        );
    }
}

export default connect(mapStateToProps)(SelectedBasketballCard);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/basketball/containers/selectedBasketballCard.js